import { z } from 'zod';
import { emailSchema } from './common.js';
/**
 * People a customer travels with, saved so a name is typed once rather than every booking.
 *
 * The fields are deliberately few. Everything here is transcribed by a passenger on a
 * phone, and every optional box is one more thing to get wrong for a feature whose whole
 * point is typing less.
 */
/**
 * Trimmed, and long enough for a full name in this market — Congolese names routinely run
 * to four parts. `min(2)` rather than `min(1)`: a single character is a slip, not a person.
 */
const fullNameSchema = z.string().trim().min(2).max(80);
export const savedTravellerCreateSchema = z.object({
    fullName: fullNameSchema,
    // Empty string is accepted and stored as absent, so clearing a field in the UI does the
    // obvious thing rather than failing validation on a box the passenger just emptied.
    phone: z.string().trim().max(32).optional().or(z.literal('')),
    /**
     * Whatever number the operator asks for at boarding. Stored exactly as typed, verified
     * against nothing, and never used to identify anybody — it is a convenience, not an
     * identity document.
     */
    idNumber: z.string().trim().max(48).optional().or(z.literal('')),
    /**
     * Where this person's copy of a ticket goes when the passenger forwards one to them.
     *
     * Optional, and a traveller without one is perfectly normal — most are children or
     * relatives who will never receive their own mail. Validated as an address rather than
     * stored as typed, unlike `idNumber`: this one is actually sent to.
     */
    email: emailSchema.optional().or(z.literal('')),
});
/** Every field optional: a passenger correcting a phone number should not resend a name. */
export const savedTravellerUpdateSchema = savedTravellerCreateSchema.partial();
//# sourceMappingURL=traveller.js.map